import React from "react";
import styles from "./styles.module.scss";
import Image from "next/image";

const ProductExperiment = ({ title, text, img }) => {
  return (
    <div className="container container_xs">
      <div className={styles.experiment}>
        <div className={styles.text}>
          <label className="h4">Complete price testing toolkit</label>
          <p className="text_xl">
            Create prices and paywalls A/B-tests right out of the box – fast and
            super-easy!
            <br />
            Use the power of data to boost app revenue.
          </p>
        </div>
        <Image
          src="/images/experiments.svg"
          className={styles.img}
          width="825"
          height="702"
        />
      </div>
    </div>
  );
};

export default ProductExperiment;
